import Sticky from '_core/components/Sticky';

export default Sticky;
